import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-hdr" }
const _hoisted_4 = { class: "modal-sub" }
const _hoisted_5 = { class: "coord-grid" }
const _hoisted_6 = { class: "val mono" }
const _hoisted_7 = { class: "val mono" }
const _hoisted_8 = { class: "span-2" }
const _hoisted_9 = { class: "val mono" }
const _hoisted_10 = { class: "modal-actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "coord-grid" }
const _hoisted_13 = {
  key: 0,
  class: "field-error"
}
const _hoisted_14 = {
  key: 0,
  class: "field-error"
}
const _hoisted_15 = { class: "modal-actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]

import axios from "@/axiosInstance";
	import { ref, computed } from "vue";
	import { useToast } from "vue-toast-notification";

	
export default /*@__PURE__*/_defineComponent({
  __name: 'LocationModal',
  props: {
    deviceName: {},
    deviceId: {},
    location: {}
  },
  emits: ["close", "copy", "saved"],
  setup(__props: any, { emit: __emit }) {

	const props = __props;

	const emit = __emit;

	const toast = useToast();
	const hasLocation = computed(() => Array.isArray(props.location) && props.location.length === 2);
	const editMode = ref(!hasLocation.value); // apre direttamente in edit se non ci sono coordinate
	const saving = ref(false);
	const inputLat = ref(hasLocation.value ? String(props.location![0]) : "");
	const inputLng = ref(hasLocation.value ? String(props.location![1]) : "");
	const latError = ref("");
	const lngError = ref("");

	const formatLat = (lat: number) => `${lat >= 0 ? "N" : "S"} ${Math.abs(lat).toFixed(6)}`;
	const formatLng = (lng: number) => `${lng >= 0 ? "E" : "W"} ${Math.abs(lng).toFixed(6)}`;

	function handleArrow(e: KeyboardEvent, current: string, set: (v: string) => void) {
		if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
		e.preventDefault();
		const val = parseFloat(current);
		if (isNaN(val)) return;
		const decimals = current.includes(".") ? current.split(".")[1].length : 6;
		const precision = Math.max(decimals, 6);
		const delta = e.key === "ArrowUp" ? 0.000001 : -0.000001;
		set((val + delta).toFixed(precision));
	}

	function openEdit() {
		inputLat.value = props.location ? String(props.location[0]) : "";
		inputLng.value = props.location ? String(props.location[1]) : "";
		latError.value = "";
		lngError.value = "";
		editMode.value = true;
	}

	function validate(): boolean {
		latError.value = "";
		lngError.value = "";

		const lat = parseFloat(inputLat.value);
		const lng = parseFloat(inputLng.value);

		let ok = true;
		if (isNaN(lat) || lat < -90 || lat > 90) {
			latError.value = "Valore non valido (−90 … 90)";
			ok = false;
		}
		if (isNaN(lng) || lng < -180 || lng > 180) {
			lngError.value = "Valore non valido (−180 … 180)";
			ok = false;
		}
		return ok;
	}

	async function saveLocation() {
		if (!validate()) return;

		const lat = parseFloat(inputLat.value);
		const lng = parseFloat(inputLng.value);

		saving.value = true;
		try {
			const { data } = await axios.put(`/devices/${props.deviceId}/save-location`, {
				location: [lat, lng],
			});
			toast.success("Posizione aggiornata", { duration: 2500 });
			const updatedAt = data?.graph?.updated_at ?? new Date().toISOString();
			emit("saved", [lat, lng], updatedAt);
			editMode.value = false;
		} catch (err: any) {
			const msg = err?.response?.data?.message ?? "Errore durante il salvataggio";
			toast.error(msg, { duration: 3000 });
		} finally {
			saving.value = false;
		}
	}

	function handleClose() {
		editMode.value = false;
		emit("close");
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(editMode.value ? (hasLocation.value ? "Modifica posizione" : "Inserisci nuove coordinate") : "Dettagli posizione"), 1),
        _createElementVNode("button", {
          class: "ico-btn",
          onClick: handleClose
        }, "✕")
      ]),
      _createElementVNode("p", _hoisted_4, [
        _cache[6] || (_cache[6] = _createTextVNode(" Coordinate per ", -1)),
        _createElementVNode("strong", null, _toDisplayString(__props.deviceName || "device"), 1)
      ]),
      (!editMode.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "lbl" }, "Latitudine", -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(__props.location ? formatLat(__props.location[0]) : "—"), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "lbl" }, "Longitudine", -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(__props.location ? formatLng(__props.location[1]) : "—"), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "lbl" }, "Raw", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(__props.location ? `${__props.location[0].toFixed(6)}, ${__props.location[1].toFixed(6)}` : "—"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('copy'))),
                disabled: !__props.location
              }, "Copia", 8, _hoisted_11),
              (__props.deviceId)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-primary",
                    onClick: openEdit
                  }, _toDisplayString(hasLocation.value ? "Modifica" : "Inserisci coordinate"), 1))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "lbl" }, "Latitudine", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputLat).value = $event)),
                  class: _normalizeClass(["coord-input mono", { invalid: latError.value }]),
                  type: "number",
                  step: "any",
                  placeholder: "es. 45.410000",
                  onKeydown: _cache[2] || (_cache[2] = ($event: any) => (handleArrow($event, inputLat.value, v => inputLat.value = v)))
                }, null, 34), [
                  [_vModelText, inputLat.value]
                ]),
                (latError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(latError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "lbl" }, "Longitudine", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputLng).value = $event)),
                  class: _normalizeClass(["coord-input mono", { invalid: lngError.value }]),
                  type: "number",
                  step: "any",
                  placeholder: "es. 11.880000",
                  onKeydown: _cache[4] || (_cache[4] = ($event: any) => (handleArrow($event, inputLng.value, v => inputLng.value = v)))
                }, null, 34), [
                  [_vModelText, inputLng.value]
                ]),
                (lngError.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(lngError.value), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (editMode.value = false)),
                disabled: saving.value
              }, "Annulla", 8, _hoisted_16),
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: saveLocation,
                disabled: saving.value
              }, _toDisplayString(saving.value ? "Salvataggio…" : "Salva"), 9, _hoisted_17)
            ])
          ], 64))
    ])
  ]))
}
}

})